import React from 'react';
import * as Styles from './SectionBadge.styles';

const SectionBadge = ({ text }) => (
  <Styles.Badge>{text}</Styles.Badge>
);

export default SectionBadge;
